import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {computeIsLocalApplicationFeatureActive} from '../../../helpers/localApplicationHelpers';
import {LocalApplicationFeaturesEnum, LocalApplicationModel} from '../../../models/api/localApplicationModel';

/*
 * Props.
 */

interface SettingsDevelopersHeaderFeatureTitleProps {
  feature: LocalApplicationFeaturesEnum;
  application?: LocalApplicationModel;
}

/*
 * Component.
 */

export const SettingsDevelopersHeaderFeatureTitle: FC<SettingsDevelopersHeaderFeatureTitleProps> = (
  props,
) => {
  const {feature, application} = props;

  if (!application) {
    return null;
  }
  const isActive = computeIsLocalApplicationFeatureActive(feature, application);

  switch (feature) {
    case LocalApplicationFeaturesEnum.INBOX_SIDEPANEL: {
      if (isActive) {
        return <Trans id="settings-developers-title-feature-inbox-sidepanel-active">Edit plugin</Trans>;
      }
      return <Trans id="settings-developers-title-feature-inbox-sidepanel">Create plugin</Trans>;
    }
    case LocalApplicationFeaturesEnum.CHANNEL: {
      if (isActive) {
        return <Trans id="settings-developers-title-feature-channel-active">Edit channel type</Trans>;
      }
      return <Trans id="settings-developers-title-feature-channel">Create channel type</Trans>;
    }
    default:
      return null;
  }
};
